<ul id="detail_kosten_gebuehren" class="p-0">
  @if (termin.kostenWert !== Kosten.PREISVERHANDELTE_MASSNAHME) {
    @if (termin.kostenWert) {
      <li class="d-flex flex-column mb-2">
        <span id="detail_gesamtkosten_label" class="fw-bold">Gesamtkosten</span>
        <span id="detail_gesamtkosten" [attr.aria-label]="kostenAria">
          {{ kosten }}
          @if (termin.kostenWert !== 'KEINE_ANGABE') {
            {{ termin.kostenWaehrung }}
          }
        </span>
      </li>
    }
  }

  @if (termin.kostenBemerkung) {
    <li class="d-flex flex-column mb-2">
      <span id="detail_kostenbemerkung_label" class="fw-bold">Kosten-Bemerkung</span>
      <span
        id="detail_kostenbemerkung"
        class="keywords"
        [innerHTML]="sanitizeFunction(termin.kostenBemerkung)"
      >
      </span>
    </li>
  }

  @if (termin.angebot.zertifizierer.length! > 0) {
    <li class="d-flex flex-column mb-2">
      <span id="detail_zertifizierer_label" class="fw-bold">Zertifizierer</span>
      <span id="detail_zertifizierer">
        @for (zertifizierer of termin.angebot.zertifizierer; track zertifizierer.id) {
          <div>{{ zertifizierer.name }}</div>
        }
      </span>
    </li>
  }

  @if (termin.foerderartenBundesweit.length > 0 || termin.foerderartenBundesland.length > 0) {
    <li class="d-flex flex-column mb-2">
      <span id="detail_foerderarten_label" class="fw-bold">Förderung</span>
      @if (termin.foerderartenBundesweit.length > 0) {
        <span id="detail_foerderarten_bundesweit" class="d-flex flex-column">
          @for (foerderart of termin.foerderartenBundesweit; track foerderart.id) {
            <span>
              {{ foerderart.bezeichnung }}
            </span>
          }
        </span>
      }
      @if (termin.foerderartenBundesland.length > 0) {
        <span id="detail_foerderarten_bundesland" class="d-flex flex-column">
          @for (foerderart of termin.foerderartenBundesland; track foerderart.id) {
            <span>
              {{ foerderart.bezeichnung }}
            </span>
          }
        </span>
      }
    </li>
  }
  @if (termin.angebot.foerderung; as foerderung) {
    <li class="d-flex flex-column">
      <span id="detail_foerderung_label" class="fw-bold">Bemerkung zur Förderung</span>
      @if (termin.angebot.foerderung) {
        <span id="detail_foerderung" class="keywords" [innerHTML]="sanitizeFunction(foerderung)">
        </span>
      }
    </li>
  }
</ul>
